import { Component, inject, Input, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { WebMonthAttendanceService } from '../../Model/WebMonthAttendance/web-month-attendance.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-edit-attendance',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, LoaderComponent, DataTablesModule],
  templateUrl: './edit-attendance.component.html',
  styleUrl: './edit-attendance.component.scss'
})
export class EditAttendanceComponent {
  @Input() InputData: any;
  isDisabled: boolean = false
  activeModal = inject(NgbActiveModal);
  public User: any = null
  allSelect: boolean = false;

  DesignationLoad: any[] = [];
  ShiftLoad: any[] = [];
  DutyLoad: any[] = [];
  AttendanceRemarkLoad: any[] = [];

  Filter = {
    SelectAttendanceType: null,
    MarkAttendanceType: null,
    MarkShift: null,
    MarkDuty: null,
    MarkDesignation: null
  }

  dtoptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    processing: true,
    lengthChange: true,
    language: {
      searchPlaceholder: 'Search...',
    }
  };

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  TableDatas: any[] = []
  constructor(
    protected common: CommonService,
    private sessionService: SessionService,
    private toast: ToastService,
    private comboload: ComboService,
    private getmonthattendance: WebMonthAttendanceService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
  }
  ngOnInit(): void {
    this.ComboLoad('Designation')
    this.ComboLoad('Shift')
    this.ComboLoad('Duty')
    this.ComboLoad('Attendance Type')
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  getData() {
    this.isDisabled = true;
    const data = {
      SELECTTYPE: 2,
      MONTHNAME: this.InputData.MONTHNAME,
      YEARNAME: this.InputData.YEARNAME,
      BRANCHID: this.InputData.BRANCHID,
      CLIENTID: this.InputData.CLIENTID,
      SITEID: this.InputData.SITEID,
      EMPTYPE: this.InputData.EMPTYPE,
      EMPCODE: this.InputData.EMPCODE,
      EMPMASTERID: this.InputData.EMPMASTERID,
      FROMDATE: this.InputData.FROMDATE,
      TODATE: this.InputData.TODATE
    }
    this.getmonthattendance.GetMonthlyAttendanceSummary(data).subscribe({
      next: (response) => {
        if (response) {
          this.TableDatas = Object.values(response.Table);
          this.isDisabled = false;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Designation') {
          this.DesignationLoad = response.ComboLoad;
        } else if (Combotype == 'Shift') {
          this.ShiftLoad = response.ComboLoad;
        } else if (Combotype == 'Duty') {
          this.DutyLoad = response.ComboLoad;
        } else if (Combotype == 'Attendance Type') {
          this.AttendanceRemarkLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.Update();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  Update() {
    if (this.TableDatas.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }

    const SelectedData = this.TableDatas.filter(data => data.selected === true);

    if (this.TableDatas.length !== 0 && SelectedData.length === 0) {
      this.toast.show({ message: 'Select any data to continue', type: toastTypeEnum.warning });
      return
    }

    if (SelectedData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return;
    }

    const Data = SelectedData.map(rt => {
      return {
        DailyAttendanceInOutID: rt.DailyAttendanceInOutID,
        DesignationId: rt.DesignationID,
        DutyId: rt.DutyID,
        ShiftId: rt.ShiftID,
        AttendanceRemark: rt.AttendanceRemark,
      };
    });
    const editattendance = {
      SelectType: 'U',
      ESS_GETEMPMONTHLYATTENDANCESUMMARYUPDATE: Data,
      UserId: this.User.UserId
    }
    this.isDisabled = true;
    this.getmonthattendance.GetAttendanceSummaryUpdate(editattendance).subscribe({
      next: (data) => {
        if (data.Error_Code == '654') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              // this.getData();
              this.activeModal.close(true)
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
    this.isDisabled = false;
  }

  close() {
    this.activeModal.close()
  }

  clearAttendanceMark() {
    for (let data of this.TableDatas) {
      data.selected = false;
    }
  }

  selectAttendanceType(AttendanceType: null) {
    console.log(AttendanceType);
    for (let data of this.TableDatas) {
      if (data.AttendanceRemark === AttendanceType) {
        data.selected = true;
      } else {
        data.selected = false;
      }
    }
  }

  markShift(Shift: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to overrride shift for every selected column ?';
    modalRef.componentInstance.Button1 = 'Yes';
    modalRef.componentInstance.Button2 = 'No';
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          for (let data of this.TableDatas) {
            if (data.selected) {
              data.ShiftID = Shift;
            }
          }
        } else {
          for (let data of this.TableDatas) {
            if (data.selected) {
              if (data.ShiftID == null || data.ShiftID == '' || data.ShiftID == 0) {
                data.ShiftID = Shift;
              }
            }
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  markDuty(Duty: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal',
    });
    modalRef.componentInstance.Message = 'Do you want to overrride duty for every selected column ?'
    modalRef.componentInstance.Button1 = 'Yes';
    modalRef.componentInstance.Button2 = 'No';
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          for (let data of this.TableDatas) {
            if (data.selected) {
              for (let duty of this.DutyLoad) {
                if (duty.DutyMasterID == Duty) {
                  data.DutyID = Duty;
                }
              }
            }
          }
        } else {
          for (let data of this.TableDatas) {
            if (data.selected) {
              if (data.DutyID == null || data.DutyID == '') {
                for (let duty of this.DutyLoad) {
                  if (duty.DutyMasterID == Duty) {
                    data.DutyID = Duty;
                  }
                }
              }
            }
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  markDesignation(Designation: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal',
    });
    modalRef.componentInstance.Message = 'Do you want to overrride designation for every selected column ?'
    modalRef.componentInstance.Button1 = 'Yes';
    modalRef.componentInstance.Button2 = 'No';
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          for (let data of this.TableDatas) {
            if (data.selected) {
              for (let designation of this.DesignationLoad) {
                if (designation.DesignationMasterID == Designation) {
                  data.DesignationID = Designation
                }
              }
            }
          }
        } else {
          for (let data of this.TableDatas) {
            if (data.selected) {
              if (data.DesignationID == null || data.DesignationID == '') {
                for (let designation of this.DesignationLoad) {
                  if (designation.DesignationMasterID == Designation) {
                    data.DesignationID = Designation;
                  }
                }
              }
            }
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  markAttendanceType(AttendanceType: any) {
    for (let data of this.TableDatas) {
      if (data.selected) {
        data.AttendanceRemark = AttendanceType;
      }
    }
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    for (let data of this.TableDatas) {
      data.selected = isChecked;
    }
  }

  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
    
    const attendance = this.AttendanceRemarkLoad.find((e: any) => e.AttendanceTypeCode == shift.AttendanceRemark);
    if(attendance){
      shift.AttendanceRemark = shift.AttendanceRemark;
    }else{
      shift.AttendanceRemark = null;
    }
    
    const designation = this.DesignationLoad.find((e: any) => e.DesignationMasterID == shift.DesignationID);
    if(designation){
      shift.DesignationID = shift.DesignationID;
    }else{
      shift.DesignationID = null;
    }

    const shifts = this.ShiftLoad.find((e: any) => e.ShiftMasterID == shift.ShiftID);
    if(shifts){
      shift.ShiftID = shift.ShiftID;
    }else{
      shift.ShiftID = null;
    }

    const duty = this.DutyLoad.find((e: any) => e.DutyMasterID == shift.DutyID);
    if(duty){
      shift.DutyID = shift.DutyID;
    }else{
      shift.DutyID = null;
    }
  }

  resetSelection() {
    for (let data of this.TableDatas) {
      if (data.selected === false) {
        this.allSelect = false;
        return;
      }
    }
  }
}
